import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import type { AppTool } from '@/features/tools/types'
import { toolDisplayName } from '@/features/tools/presentation'

interface DeleteToolDialogProps {
  tool: AppTool | null
  isDeleting: boolean
  error: string | null
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
}

export function DeleteToolDialog({
  tool,
  isDeleting,
  error,
  onConfirm,
  onOpenChange,
}: DeleteToolDialogProps) {
  return (
    <AlertDialog open={tool !== null} onOpenChange={onOpenChange}>
      <AlertDialogContent size="sm">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Delete “{tool ? toolDisplayName(tool) : ''}”?
          </AlertDialogTitle>
          <AlertDialogDescription>
            {tool?.kind === 'calcom'
              ? 'This removes the tool from your organization’s tool list and disables it on every duty. Existing bookings are not cancelled.'
              : "This removes the tool for every duty that includes it, along with any duty-level overrides. This can't be undone."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {error ? <p className="text-sm text-destructive">{error}</p> : null}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={isDeleting}
            onClick={(event) => {
              // Radix closes the dialog synchronously on click; keep it up
              // (disabled) while the DELETE runs so a failure has a retry seat.
              event.preventDefault()
              onConfirm()
            }}>
            Delete tool
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
